import { render, staticRenderFns } from "./ProductsListIRR.vue?vue&type=template&id=23153d11&"
import script from "./ProductsListIRR.vue?vue&type=script&lang=js&"
export * from "./ProductsListIRR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports